import { render, staticRenderFns } from "./MPGdetail.vue?vue&type=template&id=42f30ea1&scoped=true"
import script from "./MPGdetail.vue?vue&type=script&lang=js"
export * from "./MPGdetail.vue?vue&type=script&lang=js"
import style0 from "./MPGdetail.vue?vue&type=style&index=0&id=42f30ea1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f30ea1",
  null
  
)

export default component.exports